import { TGetP5FRes } from "@sharedTypes/res.type";

import axios from "axios";

export async function GetP5F() {
  const apiUrl = "/tools/p5f/GetP5F";

  const data: TGetP5FRes = await axios
    .post(apiUrl)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
